module.exports = __webpack_public_path__ + "static/media/icon_all.19884fdb.png";